import { Grid } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";
import { EditableTable, EditableGridColDef } from "components/alove/EditableTable";
import { BatchContent } from "models/batch/BatchContent";
import { Question } from "models/batch/Question";
import { createBatchContentDO, getQuestionnairesNames, deleteBatchContentDO, updateBatchContentDO } from "utils/questionsUtils";
import { useEffect, useState } from "react";

export const QuestionQuestionnaires = ({ question }: { question: Question }) => {
  const [questionnaires, setQuestionnaires] = useState<{ label: string; value: number }[]>([]);

  useEffect(() => {
    getQuestionnairesNames().then((q) => {
      setQuestionnaires(
        Object.entries(q).map(([label, value]) => ({ label, value }))
      );
    });
  }, []);

  const columns: EditableGridColDef[] = [
    {
      field: "batchId",
      headerName: "Batch Id",
      flex: 1,
      editable: true,
      customType: "autocomplete",
      getOptions: () => questionnaires,
      valueGetter: (v: any, row: any) => row.batchId,
    },
    {
        field: "batchName",
        headerName: "Batch Name",
        flex: 3,
        valueGetter: (v, row) => row.batch?.displayName,
    },
    {
        field: "skipAllowed",
        headerName: "Skip Allowed",
        editable: true,
        type: "boolean",
        flex: 1,
    },{
        field: "defaultResponse",
        headerName: "Default Response",
        editable: true,
        flex: 1,
    },
    {
      field: "version",
      headerName: "Version",
      editable: true,
      flex: 1,
    },
  ];

  // Handler to add a new BatchContent
  const handleAddRow = async (row: Partial<BatchContent>) => {
    if (!row.batchId || !question.id) return;
    const newContent = {
      ...row,
      batchId: row.batchId,
      questionId: question.id,
    };
    await createBatchContentDO(newContent);
    // Optionally, refresh or mutate question.batchContents here if needed
  };

  // Handler to delete a BatchContent
  const handleDelRow = async (row: BatchContent) => {
    if (!row.id) return;
    await deleteBatchContentDO(row.id);
    // Optionally, refresh or mutate question.batchContents here if needed
  };

  // Handler to update a BatchContent
  const handleProcessRowUpdate = async (newRow: BatchContent, oldRow: BatchContent) => {
    if (!newRow.id) return oldRow;
    await updateBatchContentDO(newRow.id, newRow);
    return newRow;
  };

  return (
    <EditableTable
      rows={question.batchContents}
      columns={columns}
      processRowUpdate={handleProcessRowUpdate}
      modelName="Questionnaire"
      onAddRow={handleAddRow}
      onDelRow={handleDelRow}
    />
  );
};
